export default "__VITE_ASSET__0196b5e7__"